/* eslint-disable react/jsx-pascal-case */
import { Router, Redirect, Route, Switch } from "react-router-dom";
import Home from "../pages/Home/Home";
import Billing from "../pages/Billing/Billing";
import Interview from "../pages/Interview/Interview";
import PersonalDetails from "../pages/PersonalDetails/PersonalDetails";
import CompanyProfile from "../pages/CompanyProfile/CompanyProfile";
import AddEmployee from "../pages/AddEmployee/AddEmployee";
import EmpStaff from "../pages/AddEmployee/EmpStaff";
import UploadEmployeepic from "../pages/AddEmployee/UploadEmployeepic/UploadEmployeepic";
import EmpDetails from "../pages/AddEmployee/EmpDetails/EmpDetails";
import EmpHeadShot from "../pages/AddEmployee/EmpHeadShot/EmpHeadShot";
import PostGig from "../pages/GigManagement/PostGig";
import ContractGig from "../pages/PostAJob/PostJobForm/ContractGig/ContractGig";
import PerGig from "../pages/PostAJob/PostJobForm/PerGig/PerGig";
import GigDescription from "../pages/GigManagement/GigDescription/GigDescription";
import ViewGigs from "../pages/GigManagement/ViewGigs/ViewGigs";
import ProfileDetail from "../pages/ProfileDetail/ProfileDetail";
import InternalExternalDetail from "../pages/ProfileDeatailForInternalExternal/InternalExternalDetail";
import Profession from "../pages/Signup/Profession";
import SuccessScreen from "../pages/Signup/SuccessScreen/SuccessScreen";

import PostaJobBudgetForm from "../pages/PostAJob/PostJobForm/components/jobBudgetForm/JobBudgetForm";

import CompanyDetails from "../pages/CompanyProfile/CompanyDetails/CompanyDetails";
import MarqueeAlbum from "../pages/CompanyProfile/MarqueeAlbum/Marquee";
import AuthSuccess from "../pages/Auth/components/AuthSuccess";
import Followers from "../pages/CompanyProfile/Followers/Followers";
import Views from "../pages/CompanyProfile/Views/Views";
import TalentEmployer from "../pages/Signup/Signup-Steps/StepOne/TalentEmployer";
import AboutCompany from "../pages/CompanyProfile/About/About";
import QueryPage from "../pages/QueryPage/QueryPage";
import InternalTalentResultsPage from "../pages/QueryPage/InternalTalentResultsPage";
import MarketplaceTalentResultsPage from "../pages/QueryPage/MarketplaceTalentResultsPage";
import ExternalTalentResultsPage from "../pages/QueryPage/ExternalTalentResultsPage";
import CompanyLogo from "../pages/AddEmployee/CompanyLogo/CompanyLogo";
import React from "react";
import LostPassword from "../pages/Auth/components/LostPassword";
import LinkedInCheck from "../pages/Auth/components/LinkedInCheck";
import TermsOfServices from "../pages/Auth/components/TermsOfServices";
import history from "./history";
import JobListing from "../pages/JobListing/JobListing";
import ManageJobs from "../pages/ManageJobs/ManageJobs";
import CandidateSkillListing from "../pages/SkillListing/CandidateSkillListing/CandidateSKillLisitng";
import InterviewListing from "../pages/Interview/InterviewListing/InterviewListing";
import JobDetailNew from "../pages/JobListing/JobDetailNew/JobDetailNew";

import SkillMatches from "../pages/SkillMatches/MyMatches";
import PostaJob from "../pages/PostAJob/PostJobForm/components/formSecondPart/formSecondPart";
import CreateJobForm from "../pages/PostAJob/CreateJobForm/CreateJobForm";
import JobTemplate from "../pages/PostAJob/jobTemplates/jobTemplates";
import EmployerProfile from "../pages/PostAJob/EmployerProfile/EmployerDashboard";
import JobType from "../pages/Signup/JobType/JobType";
import Resume3d from "../pages/3dResume/3dResume";
import MyFavorites from "../pages/My Favorites/MyFavorites";
// import ManageTimeSheet from "../pages/ManageTimeSheet/TimesheetList";
import TimesheetDetails from "../pages/ManageTimeSheet/TimesheetDetails/TimesheetDetails";
import Payment from "../pages/Payment/Payment";
import ManageSpends from "../pages/Payment/ManageSpends/ManageSpends";
import NotificationPage from "../pages/Notifications/NotificationPage";
import MyTeams from "../pages/My Teams/Myteams";
import TeamPage from "../pages/Team/TeamPage";
import SearchCandidateMarket from "../pages/Candidate Marketing/SearchConfig";
import Add_Member from "../pages/My Teams/components/Add Member";
import Activate from "../pages/My Teams/components/Activate";
import Conversation from "../pages/Conversations/Conversations";
import OurCulturePhotos from "../pages/CompanyProfile/OurCulture/CompanyCulturePhotos/ourCulturePhotos";
import MyMatches from "../pages/My Matches/MyMatches";
import ManageCandidate from "../pages/ManageCandidate/ManageCandidate";
import MyProfile from "../pages/My Profile/myProfile";
import Subscriptions from "../pages/Subscriptions/Subscriptions";
import FindMatches from "../pages/My Matches/components/Find Matches/FindMatches";
import Ratings from "../pages/Ratings/Ratings";
import SkillListing from "../pages/SkillListing/CandidateSkillListing/CandidateSKillLisitng";
import ScrollToTop from "../components/ScrollToTop";
import { getCookie } from "../shared/helpers";
import {
  canAccessProjectsPlan,
  canUseSubscriptionFeatures,
} from "../shared/billing";
import { useSelector, useDispatch } from "react-redux";
import { fetchCreditsBalanceRequested, retractBid, userLanded } from "../redux/actions";
import FileContainer from "../components/FileContainer/FilerContainer";
import { useEffect, useState } from "react";
import { LoginRoute, RestrictLoginRoute, SignupRoute, ValidateRoute } from "./routes";
import PlaceBidCard from "../pages/Conversations/components/ChatCard/components/ReceivedBidsCard/PlaceBidCard";
import  {
  ApolloWrapper,
} from "../components/PlaceBidModal/PlacedBidModalPage";
import { v4 as uuid } from "uuid";
import { APP_NAME } from "../constants/userTrackingConstants";
import AddCandidateEmail from "../components/AddCandidateEmail/AddCandidateEmail";
import AddCandidateName from "../components/AddCandidateName/AddCandidateName";
import CandidateMobileNumber from "../components/CandidateMobile/CandidateMobileNumber";
import GigType from "../components/CandidateGigType/GigType";
import SkillListingTitle from "../components/skilllistingtitle/SkillListingTitle";
import CandidateSkills from "../components/CandidateSkills/CandidateSkills";
import CandidateSalary from "../components/CandidateSalary/CandidateSalary";
import MessageToCandidate from "../components/MessageToCandidate/MessageToCandidate";
import DesiredLocation from "../pages/PostAJob/EmployerProfile/components/DesiredLocation/DesiredLocation";
import StartDate from "../pages/PostAJob/EmployerProfile/components/StartDate/StartDate";
import Invite from "../pages/PostAJob/EmployerProfile/components/InviteTalents/Invite";
import TimeSheetStartDate from "../pages/TimeSheet/TimeSheetStartDate";
import TimeSheetStartShift from "../pages/TimeSheet/TimeSheetStartShift";
import TimeSheetEndShift from "../pages/TimeSheet/TimeSheetEndShift";
import TimeSheetWorkingHours from "../pages/TimeSheet/TimeSheetWorkingHours";
import TimeSheetEndDate from "../pages/TimeSheet/TimeSheetEndDate";
import ManageTimesheet from "../pages/ManageTimeSheet/ManageTimesheet";
import WrappedChooseGigPage from "../components/ChooseGigPage/ChooseGigPage";
import ForcePasswordChange from "../pages/Auth/components/ForcePasswordChange";
import { NewLogin } from "../pages/NewSignupFlow/Newlogin/NewLogin";
import { NewSignup } from "../pages/NewSignupFlow/NewSignup/NewSignup";
import { Signin } from "../pages/NewSignupFlow/Signin/Signin";
import { VerifyEmail } from "../pages/NewSignupFlow/VerifyEmail/VerifyEmail";
import AboutYourself from "../pages/NewSignupFlow/AboutYourself/AboutYourself";
import AboutYourCompany from "../pages/NewSignupFlow/AboutYourCompany/AboutYourCompany";
import CreateYourFirstJob from "../pages/NewSignupFlow/CreateYourFirstJob/CreateYourFirstJob";
import ManageJobsInvited from "../pages/ManageJobsInvited/ManageJobsInvited";
import ManageInvites from "../pages/ManageInvites/ManageInvites";
import TransactionHistory from "../pages/TransactionHistory/TransactionHistory";
import UpgradePlanPreview from "../pages/UpgradePlanPreview/UpgradePlanPreview";
import PaymentSuccess from "../pages/PaymentSuccess/PaymentSuccess";
import PaymentFailed from "../pages/PaymentFailed/PaymentFailed";
import { ForgotPassword } from "../pages/NewSignupFlow/NewForgptPassword/ForgotPassword";
import { ResetPassword } from "../pages/NewSignupFlow/ResetPassword/ResetPassword";
import PlaceBidEmptyScreen from "../pages/PostAJob/EmployerProfile/components/PlaceBidEmptyScreen/PlaceBidEmptyScreen";
import ManageProjects from "../pages/ManageProjects/ManageProjects";
import CreateProject from "../pages/ManageProjects/CreateProject";
import ProjectDetail from "../pages/ManageProjects/ProjectDetail";
import ProjectJobs from "../pages/ManageProjects/ProjectJobs";
import Loader from "../components/Loading/Loader";

const getStoredUserProfile = () => {
  try {
    return JSON.parse(localStorage.getItem("userProfile") || "{}") || {};
  } catch {
    return {};
  }
};

export const AppRouter = (props) => {
  const { authToken } = props;
  const dispatch = useDispatch();
  let userProfile = getStoredUserProfile();
  const finishProfile = getCookie("finishProfile");
  const { finisProf } = useSelector((state) => state.profileReducer);
  const [ipaddress, setIpaddress] = useState("");
  const [pathname, setPathname] = useState(history.location.pathname);
  const initialPaths = pathname === "/" ? "/" : pathname.split("/")[1];

  useEffect(() => history.listen(({ pathname }) => setPathname(pathname)), []);

  const MasterProtectedRoute = ({ children, ...rest }) => {
    const profile = getStoredUserProfile();
    const isAuthenticated = authToken != null || getCookie("token") != null;
    const isMasterAccount = profile?.MasterAccountId == null;

    if (!isAuthenticated) {
      return (
        <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
      );
    }
    if (!isMasterAccount) {
      return <Redirect to="/employerdashboard" />;
    }
    return <Route {...rest}>{children}</Route>;
  };

  const EnterpriseProjectRoute = ({ children, ...rest }) => {
    const isAuthenticated = authToken != null || getCookie("token") != null;
    const userProfile = getStoredUserProfile();
    const subscriptionFeaturesEnabled = canUseSubscriptionFeatures(userProfile);
    const creditsBalance = useSelector((state) => state.plansReducer?.creditsBalance);
    const creditsBalanceLoading = useSelector(
      (state) => state.plansReducer?.creditsBalanceLoading
    );
    const creditsBalanceLoaded = useSelector(
      (state) => state.plansReducer?.creditsBalanceLoaded
    );

    useEffect(() => {
      if (
        isAuthenticated &&
        subscriptionFeaturesEnabled &&
        !creditsBalanceLoading &&
        !creditsBalanceLoaded
      ) {
        dispatch(fetchCreditsBalanceRequested());
      }
    }, [
      isAuthenticated,
      subscriptionFeaturesEnabled,
      creditsBalanceLoading,
      creditsBalanceLoaded,
      dispatch,
    ]);

    if (!isAuthenticated) {
      return (
        <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
      );
    }

    if (!subscriptionFeaturesEnabled) {
      return <Redirect to="/employerdashboard" />;
    }

    if (creditsBalanceLoading || !creditsBalanceLoaded) {
      return <Loader />;
    }

    if (!canAccessProjectsPlan(creditsBalance)) {
      return <Redirect to="/employerdashboard" />;
    }

    return <Route {...rest}>{children}</Route>;
  };

  useEffect(() => {
    dispatch(
      userLanded({
        uuid: localStorage.getItem("uuid") || uuid(),
        pageType: null,
        event: "USER_LANDED",
        page: null,
        appName: APP_NAME.EMPLOYER,
        url: window.location.href,
      }),
    );
  }, []);

  return (
    <div
      className={
        initialPaths == "/" ||
        initialPaths == "employerdashboard" ||
        initialPaths === "login" ||
        initialPaths === "signin" ||
        initialPaths === "signup" ||
        initialPaths === "about-yourself" ||
        initialPaths === "about-your-company" ||
        initialPaths === "create-your-first-job"
          ? ""
          : "headerSpaceRouter"
      }
      // aria-details={((!userProfile?.verification?.email && finishProfile=="true") && finisProf) && "unverified-header-space"}
    >
      <Router history={history} basename="/employer">
        <ScrollToTop />
        {/*<Header changeStage={props.shareStage} stage={props.stage} />*/}
        <Switch>
          <Route exact path="/upgrade-plan-preview">
            <UpgradePlanPreview />
          </Route>
          <LoginRoute exact auth={authToken} path="/success">
          {/* <ValidateRoute> */}
            <PaymentSuccess />
          {/* </ValidateRoute> */}
          </LoginRoute>
          <LoginRoute exact auth={authToken} path="/canceled">
            <PaymentFailed />
          </LoginRoute>
          {/* <Route exact path="/">
            <Home />
          </Route> */}
          <Route exact path="/">
            <AuthSuccess ipAddress={ipaddress} />
          </Route>
          <Route exact path="/force-password-change">
            <ForcePasswordChange />
          </Route>

          <LoginRoute exact auth={authToken} path={"/interview/schedule"}>
            <Interview />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/personaldetails"}>
            <PersonalDetails />
          </LoginRoute>

          <LoginRoute exact path="/companyprofile" component={CompanyProfile} />
          <LoginRoute
            exact
            auth={authToken}
            path={"/companyprofile/addemployee"}
          >
            <AddEmployee />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/companyprofile/empstaff"}>
            <EmpStaff />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/editBidPage"}>
            <PlaceBidCard />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/editPlaceBidPage"}>
            <ApolloWrapper />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/uploademployeepic"}>
            <UploadEmployeepic />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/myprofile"}>
          <LoginRoute>
            <MyProfile />
          </LoginRoute>
          </LoginRoute>
          <MasterProtectedRoute exact path={"/transaction-history"}>
            <TransactionHistory />
          </MasterProtectedRoute>
          <LoginRoute exact auth={authToken} path={"/CompanyLogo"}>
            <CompanyLogo />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/managecandidate"}>
          <ValidateRoute>
            <ManageCandidate />
          </ValidateRoute>
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/manage-timesheet/:id"}>
            <ManageTimesheet />
          </LoginRoute>
          <LoginRoute
            exact
            auth={authToken}
            path={"/companyprofile/addemployee/empdetails"}
          >
            <EmpDetails />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path={"/empheadshot"}>
            <EmpHeadShot />
          </LoginRoute>

          <LoginRoute exact path={"/per-gig"} auth={authToken}>
            <PerGig />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/job-type"}>
            <JobType />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/contract-gig"}>
            <ContractGig />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/gig-description"}>
            <GigDescription />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/view-gig"}>
            <ViewGigs />
          </LoginRoute>
          {/* <Route exact path={"/conversations/:id"}> */}
          <LoginRoute exact auth={authToken} path={"/conversations/:id?"}>
          <ValidateRoute>
            <Conversation />
          </ValidateRoute>
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/resume-3d"}>
            <Resume3d />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/managejobs"}>
          <ValidateRoute>
            <JobListing />
          </ValidateRoute>
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/joblisting"}>
           <ValidateRoute>
            <ManageJobs />
           </ValidateRoute>
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/manage-invites"}>
            <ManageInvites />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/invited-talents/:id"}>
            <ManageJobsInvited />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/mymatches"}>
            <MyMatches />
          </LoginRoute>

          <LoginRoute exact path={"/findmatches/:id"}>
            <FindMatches />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/skillListing"}>
            <SkillListing />
          </LoginRoute>
          <LoginRoute exact path={"/employerdashboard"} auth={authToken}>
          <ValidateRoute>
            <EmployerProfile />
          </ValidateRoute>
          </LoginRoute>
          <Route exact path={"/abc"}> <ValidateRoute><div>Hello world</div></ValidateRoute></Route>
          <LoginRoute exact path={"/empty-state-screen"} auth={authToken}>
            <PlaceBidEmptyScreen />
          </LoginRoute>
          <LoginRoute exact path={"/inviteTalents"} auth={authToken}>
            <Invite />
          </LoginRoute>

          <LoginRoute exact auth={authToken} path={"/jobdetail/:id"}>
              <JobDetailNew />
          </LoginRoute>

          <LoginRoute
            exact
            auth={authToken}
            path={"/companyprofile/companyculturephotos"}
          >
            <ValidateRoute>
            <OurCulturePhotos />
            </ValidateRoute>
          </LoginRoute>

          {/* <LoginRoute exact auth={authToken} path={"/profiledetail/:id"}>
                <ProfileDetail />
              </LoginRoute> */}
          <LoginRoute exact auth={authToken} path={"/employerprofession"}>
            <Profession />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/allset"}>
            <SuccessScreen />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/payment"}>
            <Payment />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/managespends"}>
            <ManageSpends />
          </LoginRoute>
          <LoginRoute
            exact
            auth={authToken}
            path={"/companyprofile/companydetails"}
          >
            <CompanyDetails />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/updatecompanydetails"}>
            <CompanyDetails />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/companydetails"}>
            <CompanyDetails />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/skillmatches"}>
            <SkillMatches />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/postjob"}>
            <PostGig />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/create-job"}>
            <ValidateRoute>
            <CreateJobForm />
            </ValidateRoute>
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/postjob/secondstep"}>
            <PostaJob />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/postjob/budgetform"}>
            <PostaJobBudgetForm />
          </LoginRoute>
          <EnterpriseProjectRoute exact path={"/manage-projects"}>
            <ManageProjects />
          </EnterpriseProjectRoute>
          <EnterpriseProjectRoute exact path={"/manage-projects/create"}>
            <CreateProject />
          </EnterpriseProjectRoute>
          <EnterpriseProjectRoute exact path={"/manage-projects/edit/:id"}>
            <CreateProject />
          </EnterpriseProjectRoute>
          <EnterpriseProjectRoute exact path={"/manage-projects/:id/jobs"}>
            <ProjectJobs />
          </EnterpriseProjectRoute>
          <EnterpriseProjectRoute exact path={"/manage-projects/:id"}>
            <ProjectDetail />
          </EnterpriseProjectRoute>
          <LoginRoute exact auth={authToken} path={"/ratings"}>
            <Ratings />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path={"/marqueealbum"}>
            <MarqueeAlbum />
          </LoginRoute>

          <LoginRoute exact auth={authToken} path={"/followers"}>
            <Followers />
          </LoginRoute>

          <LoginRoute exact auth={authToken} path={"/followers/:id"}>
            <Followers />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/views"}>
            <Views />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/talentemployer"}>
            <TalentEmployer />
          </LoginRoute>
          <LoginRoute
            exact
            auth={authToken}
            path={"/companyprofile/aboutcompany"}
          >
            <AboutCompany />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/myteams"}>
            <MyTeams />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/team"}>
            <TeamPage />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/myteams/addmember"}>
            <Add_Member />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/myteams/activate"}>
            <Activate />
          </LoginRoute>

          <LoginRoute exact auth={authToken} path={"/candidateskilllisting"}>
            <CandidateSkillListing />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/candidatemarketing"}>
            <SearchCandidateMarket />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path={"/view-interviews"}>
            <InterviewListing />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/myfavourites"}>
            <MyFavorites />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/postajob/choosetemplate"}>
            <JobTemplate />
          </LoginRoute>
          <Route exact path={"/timesheet/list"}>
            {/* <ManageTimeSheet /> */}
          </Route>
          <Route exact path={"/timesheet/details"}>
            <TimesheetDetails />
          </Route>
          <LoginRoute auth={authToken} exact path={"/notification"}>
            <NotificationPage />
          </LoginRoute>
          <Route exact path={"/subscriptions-main"}>
            <Subscriptions />
          </Route>
          <Route exact path={"/billing"}>
            <Billing />
          </Route>
          <Route exact path="/terms">
            <TermsOfServices />
          </Route>
          <Route exact path={"/filecontainer"}>
            <FileContainer />
          </Route>

          <RestrictLoginRoute exact auth={authToken} path="/login">
            <Route component={NewLogin} />
          </RestrictLoginRoute>
          <RestrictLoginRoute exact auth={authToken} path="/signin">
            <Route component={Signin} />
          </RestrictLoginRoute>
          <RestrictLoginRoute exact auth={authToken} path="/signup">
            <Route component={NewSignup} />
          </RestrictLoginRoute>
          <Route exact path="/verify-email">
            <VerifyEmail />
          </Route>
          <RestrictLoginRoute auth={authToken} exact path="/forgot">
            <Route component={ForgotPassword} />
          </RestrictLoginRoute>
          <RestrictLoginRoute auth={authToken} exact path="/reset-password">
            <ResetPassword />
          </RestrictLoginRoute>
          {/* <Route exact path="/signup" component={NewSignup} /> */}
          {/* <Route exact path="/reset-password" component={ResetPassword} /> */}

          <SignupRoute exact path="/about-yourself">
            <AboutYourself />
          </SignupRoute>

          <SignupRoute exact path="/about-your-company">
            <AboutYourCompany />
          </SignupRoute>

          <SignupRoute exact path="/create-your-first-job">
            <CreateYourFirstJob />
          </SignupRoute>
          <Route exact path="/auth">
            <AuthSuccess />
          </Route>
          <Route exact path="/internal/:searchValue">
            <InternalTalentResultsPage />
          </Route>
          <Route exact path="/internal">
            <InternalTalentResultsPage />
          </Route>
          <Route exact path="/marketplace/:searchValue">
            <MarketplaceTalentResultsPage />
          </Route>
          <Route exact path="/marketplace">
            <MarketplaceTalentResultsPage />
          </Route>
          <Route exact path="/external/:searchValue">
            <ExternalTalentResultsPage />
          </Route>
          <Route exact path="/external">
            <ExternalTalentResultsPage />
          </Route>
          <Route exact path="/query/:searchValue" component={QueryPage} />
          <Route exact path="/query" component={QueryPage} />
          {/* <Route exact path={"/profiledetail/:id"} component={ProfileDetail} /> */}
          <LoginRoute
            exact
            auth={authToken}
            path={"/profiledetail/:id"}
            render={(props) => (
              <InternalExternalDetail {...props} mode="internal" />
            )}
          />
          <LoginRoute
            exact
            auth={authToken}
            path="/internal-detail/:id"
            render={(props) => (
              <InternalExternalDetail {...props} mode="internal" />
            )}
          />
          <LoginRoute
            exact
            auth={authToken}
            path="/external-detail/:id"
            render={(props) => (
              <InternalExternalDetail {...props} mode="external" />
            )}
          />
          <LoginRoute exact auth={authToken} path={"/invitedTalent/:id"}>
            <ProfileDetail isInvited={true} />
          </LoginRoute>
          <Route exact path="/" component={Home} />
          <Route exact path="/forgot" component={LostPassword} />
          <Route path="/auth" component={AuthSuccess} />
          <Route exact path="/linkcheck" component={LinkedInCheck} />
          <Route exact path="/terms" component={TermsOfServices} />
          <LoginRoute auth={authToken} exact path="/add-candidate-email">
            <AddCandidateEmail />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/add-candidate">
            <AddCandidateEmail isCandidateRoute={true} />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/add-candidate-name">
            <AddCandidateName />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/candidate-number">
            <CandidateMobileNumber />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/select-gig-type">
            <GigType />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/gig-title">
            <SkillListingTitle />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/candidate-skill">
            <CandidateSkills />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/candidate-salary">
            <CandidateSalary />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/message-candidate">
            <MessageToCandidate />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/location">
            <DesiredLocation />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/date">
            <StartDate />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path={"/select-gig-type"}>
            <GigType />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/start-date">
            <TimeSheetStartDate />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/end-date">
            <TimeSheetEndDate />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/working-hours">
            <TimeSheetWorkingHours />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/start-shift">
            <TimeSheetStartShift />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/end-shift">
            <TimeSheetEndShift />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path={"/choose-gig"}>
            <WrappedChooseGigPage />
          </LoginRoute>
        </Switch>
      </Router>
    </div>
  );
};
